module.exports = __webpack_public_path__ + "static/media/sports-card.8398d84a.svg";